import { Stack, Flex } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';

import Dialog from '~/domains/design-system/components/Dialog/Dialog';
import { Button } from '~/domains/design-system/Button';
import { Text } from '~/domains/design-system/Text';
import { Title } from '~/domains/design-system/Title';
import type { AlternatesContent } from '~/pages/api/gamecenter/alternates/[league]';
import type { LeagueAlias } from '~/domains/common/enums/league-alias.enum';

type PickAlternatesModalProps = {
  isOpen: boolean;
  isClosing?: boolean;
  onClose: () => void;
  isCloseDisabled?: boolean;
  league: LeagueAlias;
  alternatesData?: AlternatesContent;
};

function PickAlternatesModal({
  isOpen,
  isClosing,
  onClose,
  isCloseDisabled,
  league,
  alternatesData,
}: PickAlternatesModalProps) {
  const { t } = useTranslation('contest');
  return (
    <Dialog
      type={{
        desktop: 'modal',
        mobile: 'drawer',
      }}
      isOpen={isOpen}
      isClosing={isClosing}
      onClose={isCloseDisabled ? undefined : onClose}
    >
      <Stack spacing="lg" w={{ base: '100%', md: 400 }} p="md">
        <Flex justify="center" align="center">
          <Title variant="headline-xl" align="center">
            {t('common.modals.pickAlternatesModal.title')}
          </Title>
        </Flex>

        {alternatesData && alternatesData.description?.length > 0 ? (
          <Stack spacing="sm">
            {alternatesData.description.map((line) => (
              <Text key={line} align="center">
                {line}
              </Text>
            ))}
          </Stack>
        ) : (
          <Text align="center">{t('common.modals.pickAlternatesModal.noDataFound')}</Text>
        )}

        <Button variant="tertiary-fill" size="medium" fullWidth onClick={onClose}>
          {t('common.modals.pickAlternatesModal.dismiss')}
        </Button>
      </Stack>
    </Dialog>
  );
}

export default PickAlternatesModal;
